var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('hamburguer')],1),_c('div',{staticClass:"col text-right"},[_vm._v(" "+_vm._s(_vm.email)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }